import React from 'react';
import { MultiSelect } from '@planner/bundles/main/admin/components/MultiSelect';
import type { Question } from '../../../../types/publicForm.types';
import { QuestionFooter } from './QuestionHelpers';

interface SelectQuestionProps {
  question: Question;
  value: any;
  onChange: (value: any) => void;
  onBlur: () => void;
  error?: string;
  primaryColor: string;
  isMulti?: boolean;
  moreInfo?: string;
  isMoreInfoExpanded?: boolean;
  onToggleMoreInfo?: () => void;
  onDropdownToggle?: (isOpen: boolean) => void;
}

export interface Option {
  value: string;
  label: string;
}

export const SelectQuestion: React.FC<SelectQuestionProps> = ({
  question,
  value,
  onChange,
  onBlur,
  error,
  primaryColor,
  isMulti = false,
  moreInfo,
  isMoreInfoExpanded,
  onToggleMoreInfo,
  onDropdownToggle,
}) => {
  if (!question.showAnswerOptions || !question.answers) {
    return null;
  }

  const options: Option[] = question.answers
    .filter(answer => !answer._destroy)
    .map(answer => ({
      value: String(answer.id),
      label: answer.answer,
    }));

  // For single select, we need to convert the value to an array for MultiSelect
  // and convert back to single value on change
  const selectedValues = isMulti
    ? (Array.isArray(value) ? value.map(String) : [])
    : (value ? [String(value)] : []);

  const handleChange = (values: string[]) => {
    if (isMulti) {
      onChange(values);
    } else {
      // For single select, take the first value or empty string
      onChange(values.length > 0 ? values[0] : '');
    }
    onBlur();
  };

  console.log('isMulti:', isMulti);
  return (
    <div>
      <div className={error ? 'ring-2 ring-red-500 rounded-lg' : ''}>
        <MultiSelect
          options={options}
          value={selectedValues}
          onChange={handleChange}
          placeholder={isMulti ? 'Select options' : 'Select an option'}
          isMulti={isMulti}
          id={question.id}
          onOpenChange={onDropdownToggle}
        />
      </div>
      <QuestionFooter
        error={error}
        helpText={question.description}
        moreInfo={moreInfo}
        isMoreInfoExpanded={isMoreInfoExpanded}
        onToggleMoreInfo={onToggleMoreInfo}
      />
    </div>
  );
};